type AuthIllustrationPanelProps = {
  variant?: 'register' | 'login';
};

const ILLUSTRATION_SRC = '/static/register-illustration.svg';

/**
 * Kayıt / giriş sol panel görseli (public/static/register-illustration.svg).
 * next/image SVG'de kırık görünebiliyor; düz img kullanıyoruz.
 */
export default function AuthIllustrationPanel({ variant = 'register' }: AuthIllustrationPanelProps) {
  const alt =
    variant === 'register'
      ? 'Create your Alsero Tours account'
      : 'Sign in to your Alsero Tours account';

  return (
    <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-gray-100 to-gray-200 items-center justify-center p-12 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-20 left-20 w-32 h-32 bg-red-500 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-red-400 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-red-300 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center max-w-md w-full">
        {/* eslint-disable-next-line @next/next/no-img-element -- static SVG; next/image breaks this asset */}
        <img
          src={ILLUSTRATION_SRC}
          alt={alt}
          width={397}
          height={451}
          className="w-full max-w-[320px] h-auto drop-shadow-sm"
          decoding="async"
        />
      </div>
    </div>
  );
}
